/**
 * [polecenie właściciela 2026-09-29] „z podziałem na te kategorie NIS2, ISO itp.” — KATEGORIE OBSZARÓW TEMATYCZNYCH.
 *
 * Jedno miejsce etykiet kategorii (pole `zrodlo` obszaru z GET /api/polityki/obszary*): strona obszarów (/polityki/obszary)
 * i zakładka „Procedury i instrukcje” w Mój Dział → Dokumenty grupują po tym samym słowniku. Kolejność tablicy = kolejność
 * sekcji na ekranie. Źródło nieznane (np. nowa kategoria z serwera przed wdrożeniem frontu) trafia do „Własne” — nigdy
 * nie znika z listy.
 */
export const KATEGORIE_OBSZAROW = [
    { klucz: "nis2", etykieta: "NIS2 (art. 21 ust. 2)", krotka: "NIS2" },
    { klucz: "iso", etykieta: "Normy ISO", krotka: "ISO" },
    { klucz: "wlasny", etykieta: "Własne", krotka: "własny" },
];

const ZNANE = new Set(KATEGORIE_OBSZAROW.map((k) => k.klucz));

/** Klucz kategorii dla źródła obszaru; nieznane i puste → „wlasny”. */
export const kategoriaObszaru = (zrodlo) => (ZNANE.has(zrodlo) ? zrodlo : "wlasny");

/** Krótka etykieta znaczka kategorii („NIS2”, „ISO”, „własny”). */
export const etykietaKategoriiKrotka = (zrodlo) =>
    KATEGORIE_OBSZAROW.find((k) => k.klucz === kategoriaObszaru(zrodlo)).krotka;
